module.exports = __webpack_public_path__ + "static/img/BE.59ca6fd0.svg";